import React, { ReactElement, useState } from 'react'
import { Box } from '@material-ui/core'
import PostGraduationTabButton from './PostGraduationTabButton'
import { useStyles } from './PostGraduationTabs.styles'

type Props = {
  children: ReactElement[]
}

const PostGraduationTabs = ({ children }: Props) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const classes = useStyles()
  return (
    <Box>
      <ul className={classes.tabList}>
        {children.map((item, index) => (
          <PostGraduationTabButton
            key={index}
            title={item.props.title}
            index={index}
            active={selectedTab === index}
            disabled={item.props.disabled}
            setSelectedTab={setSelectedTab}
          />
        ))}
      </ul>
      {children[selectedTab]}
    </Box>
  )
}

export default PostGraduationTabs
